import Vue from 'vue';
import { router } from '../../routes';

export default {
  namespaced: true,
  state: {
    registration: '/api/registration/validate',
    registrationFinish: '/api/registration',
    auth: '/api/auth',
    passwordRecover: '/api/recover',
    changePassword: '/api/profile/password',
    order: '/api/order',
    quickOrder: '/api/quick-order',
    feedback: '/api/feedback',
    feedbackOwner: '/api/director',
    callback: '/api/callback',
    promo: '/api/promo',
    sendCode: '/api/sendCode',
    updateProfile: '/api/profile/update',
    updateValidate: '/api/profile/updateValidate',
    deleteOldAddress: '/api/profile/address/delete',
    profileNotifications: '/api/profile/notify',
    codeConfirm: '',
    addNewAddressApi: '/api/profile/addressAdd',
    updAddress: '/api/profile/addressUpd',
    deleteAddress: '/api/profile/addressDell',
    checkCode: '/api/checkCode',
    sendCodeRecover: '/api/sendCodeRecovery',

    passwordValidate: '/api/profile/passwordValidate',
    logOut: '/api/logout', //get
  },
  actions: {
    async fetchRequest({ commit }, data) {
      Vue.http.post(data.url, data.form).then(
        (obj) => {
          data.success(obj);
        },
        (e) => {
          data.error();
        }
      );
    },
    async logOut({ commit, state }) {
      Vue.http.get(state.logOut).then(
        (obj) => {
          commit('params/setAuthOff', null, { root: true });
          router.push('/');
        },
        (e) => {
          console.log('logOut error', e);
        }
      );
    },
    async isAuth({ commit, state }) {
      Vue.http.get(state.auth).then(
        (obj) => {
          if (obj.body) {
            commit('params/setAuthOn', null, { root: true });
          } else commit('params/setAuthOff', null, { root: true });
        },
        (e) => {
          commit('params/setAuthOff', null, { root: true });
        }
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/api.js